import { ReactNode } from "react";

import { useLocation } from "react-router-dom";

import { SentryErrorBoundary } from "~/components/SentryErrorBoundary";

interface RoutedErrorBoundaryProps {
  children: ReactNode;
}

/**
 * Error boundary for the routed app that resets on navigation. Keyed by pathname,
 * so a crash on one page no longer leaves the whole app stuck on "Algo salió mal"
 * until a full reload — navigating to another route mounts a fresh boundary and
 * recovers. Route elements already remount per navigation, so keying here adds no
 * extra churn. Must render inside the router (uses `useLocation`); the top-level
 * `SentryErrorBoundary` in `App.tsx` remains as a last-resort catch for
 * provider/router crashes.
 */
export const RoutedErrorBoundary = ({ children }: RoutedErrorBoundaryProps) => {
  const location = useLocation();
  return <SentryErrorBoundary key={location.pathname}>{children}</SentryErrorBoundary>;
};
